import { MutationTree, ActionTree, Module } from 'vuex';
import { RootState, ProfilesState } from './../types';
import FRTBApi from '@/api/frtb.api';
import _ from 'lodash';
import { Profile } from '@/store/types';

const state: ProfilesState = {
  profileShowingOnGraph: {},
  profilesLoading: false,
  profiles: undefined,
  loadedProfile: {},
  selectedProfile: {},
  profileToRepopulate: {},
  profileToSave: {},
  profileToDelete: {},
  clearGraphStickyColumnsTrigger: 0,
  clearSelectionsTrigger: 0,
  asOfError: undefined
};

const mutations: MutationTree<ProfilesState> = {
  setCurrentProfileShowingOnGraph(profilesState, profileShowingOnGraph?: any) {
    profilesState.profileShowingOnGraph = profileShowingOnGraph || {};
  },
  setProfiles(profilesState, replacementProfiles?: Profile[]) {
    profilesState.profiles = replacementProfiles || [];
  },
  setProfileToSave(profilesState, profileToSave?: any) {
    profilesState.profileToSave = profileToSave || {};
  },
  setProfileToDelete(profilesState, profileToDelete?: any) {
    profilesState.profileToDelete = profileToDelete || {};
  },
  setProfilesLoading(profilesState, profilesLoading: boolean) {
    profilesState.profilesLoading = profilesLoading || false;
  },
  addToProfiles(profilesState, newProfile: Profile) {
    profilesState.profiles = profilesState.profiles ? profilesState.profiles.concat(newProfile) : [newProfile];
  },
  removeFromProfiles(profilesState, profileId: string) {
    if (!profilesState.profiles || (profilesState.profiles && !profilesState.profiles.length)) {
      return;
    }
    const index = profilesState.profiles.findIndex((prof: any) => prof.id === profileId);
    const arr = profilesState.profiles ? profilesState.profiles.slice() : [];
    arr.splice(index, 1);
    profilesState.profiles = arr;
  },
  updateProfile(profilesState, newProfile: Profile) {
    const newArr = profilesState.profiles ? profilesState.profiles.map((prof) => {
      if (prof.id === newProfile.id) {
        return newProfile;
      }
      return prof;
    }) : [];
    profilesState.profiles = newArr;
  },
  setSelectedProfile(profilesState, selectedProfile?: {}) {
    profilesState.selectedProfile = selectedProfile || {};
  },
  setLoadedProfile(profilesState, loadedProfile?: {}) {
    profilesState.loadedProfile = loadedProfile || {};
  },
  triggerClearGraphStickyColumns(profilesState) {
    profilesState.clearGraphStickyColumnsTrigger = profilesState.clearGraphStickyColumnsTrigger + 1;
  },
  triggerClearSelections(profilesState) {
    profilesState.clearSelectionsTrigger = profilesState.clearSelectionsTrigger + 1;
  },
  setAsOfError(profilesState, asOfError?: string) {
    profilesState.asOfError = asOfError || undefined;
  }
};

const actions: ActionTree<ProfilesState, RootState> = {
  async getProfiles(context) {
    context.commit('setProfilesLoading', true);
    if (context.state.profiles) {
      context.commit('setProfilesLoading', false);
      return context.state.profiles;
    } else {
      let res = await FRTBApi.getProfiles();
      res = res.data.data.filter((obj: any) => {
        if (obj.data.bucket) {
          return false;
        }
        return true;
      }).map((obj: any) => {
        return {
          ...obj.data,
          id: obj.id
        };
      });


      context.commit('setProfiles', res);
      context.commit('setProfilesLoading', false);
      return context.state.profiles;
    }
  },
  async saveProfile(context, profile) {
    const res = await FRTBApi.saveProfile(profile);
    if (res.id) {
      profile = { ...profile, id: res.id };
      context.commit('addToProfiles', profile);
      context.commit('setLoadedProfile', profile);
    }
    return res;
  },
  async deleteProfile(context, profile) {
    const res = await FRTBApi.deleteProfile(profile.id, profile);
    context.commit('removeFromProfiles', profile.id);
    context.dispatch('clearSelections');
    return res;
  },
  async replaceProfile(context, profile) {
    const id = profile.id;
    delete profile.id;
    const res = await FRTBApi.replaceProfile(id, profile);

    profile = { ...profile, id };
    context.commit('updateProfile', profile);
    context.commit('setSelectedProfile', profile);

    return res;
  },
  async deleteAllProfiles(context) {
    if (context.state.profiles && context.state.profiles.length) {
      const promises: any[] = context.state.profiles.map((prof: any) => {
        const id = prof.id;
        return FRTBApi.deleteProfile(id, prof);
      });

      const res = await Promise.all(promises);
      context.commit('setToastSuccess', 'Deleted Profiles');
      context.commit('setProfiles');
      context.commit('setSelectedProfile');
      context.commit('setLoadedProfile');
      return;
    }
  }
};

export const profiles: Module<ProfilesState, RootState> = {
  state,
  mutations,
  actions
};
